var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "main-row" },
    [
      _c(
        "v-col",
        { staticClass: "ta-c", attrs: { cols: "12" } },
        [
          _c("shipment-validation-summary", {
            attrs: {
              display: _vm.showPendingOrderSummaryPopup,
              errors: _vm.pendingOrderValidationErrors,
              booking: false,
            },
            on: {
              hide: function ($event) {
                _vm.showPendingOrderSummaryPopup = false
              },
            },
          }),
          _c("shipment-validation-summary", {
            attrs: {
              display: _vm.showSendBidToCarriersSummaryPopup,
              errors: _vm.pendingOrderValidationErrors,
              booking: false,
              sendBid: true,
            },
            on: {
              hide: function ($event) {
                _vm.showSendBidToCarriersSummaryPopup = false
              },
            },
          }),
          _c("shipment-validation-summary", {
            attrs: {
              display: _vm.showBookValidationSummaryPopup,
              errors: _vm.bookShipmentValidationErrors,
              booking: true,
            },
            on: {
              hide: function ($event) {
                _vm.showBookValidationSummaryPopup = false
              },
            },
          }),
          _vm.showTimelineAndButtons
            ? _c("smb-timeline", { attrs: { isEdit: true } })
            : _vm._e(),
          _c("location-and-time", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLocationAndTime,
                expression: "showLocationAndTime",
              },
            ],
          }),
          _c("add-edit-shipment-form-packaging", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPackaging,
                expression: "showPackaging",
              },
            ],
            attrs: { userId: _vm.userId, accountId: _vm.accountId },
          }),
          _c("smb-equipment", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showServiceType,
                expression: "showServiceType",
              },
            ],
          }),
          _c("add-edit-shipment-special-instructions-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSmbSpecialInstructions,
                expression: "showSmbSpecialInstructions",
              },
            ],
          }),
          _c("smb-target-rate", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSmbTargetRate,
                expression: "showSmbTargetRate",
              },
            ],
          }),
          _c("smb-review", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSmbReview,
                expression: "showSmbReview",
              },
            ],
            on: {
              "book-request-invalid": function () {
                return (_vm.showBookValidationSummaryPopup = true)
              },
              "save-and-send-requests-to-carriers":
                _vm.saveAndSendRequestsToCarriers,
            },
          }),
          _c("add-edit-shipment-form-actions", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTimelineAndButtons,
                expression: "showTimelineAndButtons",
              },
            ],
            attrs: {
              showCargoCoverage: _vm.saveShipmentRequest.cargoCoverageNeeded,
              smb: true,
            },
            on: { saveForLater: _vm.saveForLater },
          }),
          _c("confirm-cancel-shipment", {
            attrs: { display: _vm.showConfirmCancelPopup, smb: true },
            on: {
              hide: function ($event) {
                _vm.showConfirmCancelPopup = false
              },
            },
          }),
          _c("save-shipment-errors", {
            attrs: {
              display: _vm.showSaveShipmentServerErrorsPopup,
              error: _vm.saveShipmentServerErrors,
            },
            on: {
              hide: function ($event) {
                _vm.showSaveShipmentServerErrorsPopup = false
              },
            },
          }),
          _c("save-shipment-errors", {
            attrs: {
              display: _vm.showNoCarrierRatesPopup,
              header: "Sorry, there are no approved rates for your request",
              error: "Please update the shipment and try again",
              "rating-error": true,
            },
            on: {
              hide: function ($event) {
                _vm.showNoCarrierRatesPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-overlay",
            {
              attrs: {
                value: _vm.showLoadingScreen,
                opacity: "0.9",
                color: "#fff",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-n16" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center",
                      class: { "px-6": _vm.smAndDown },
                    },
                    [
                      _c("img", {
                        staticClass: "rotating",
                        attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                      }),
                      _c("p", {
                        staticClass: "overlay-txt mt-5",
                        domProps: {
                          innerHTML: _vm._s(_vm.loadingScreenMessage),
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-overlay",
            {
              attrs: {
                value: _vm.showSavedShipmentScreen,
                opacity: "0.9",
                color: "#fff",
              },
            },
            [
              _c("saved-pending-order-prompt", {
                attrs: { orderId: _vm.shipmentId },
              }),
            ],
            1
          ),
          _c("leaving-soon", {
            attrs: { display: _vm.leavingSoon },
            on: {
              hide: function ($event) {
                _vm.leavingSoon = false
              },
              saveForLater: _vm.sendCreateOrderRequest,
            },
          }),
          _vm.showWelcomeBackScreen
            ? _c("welcome-back", { on: { hide: _vm.continueEditing } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }